<template>
    <div id="page-keys_sftp">
        <div>
            <v-breadcrumbs :items="breadcrumbs">
                <v-icon slot="divider">forward</v-icon>
            </v-breadcrumbs>
        </div>
        <v-container fluid fill-height>
            <v-row align-center justify-center>
                <v-col xs="12">
                    <base-material-card color="primary" icon="library_books" title="Administrar Claves SFTP"
                        class="elevation-1 px-5 py-3">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn fab dark x-small color="green" title="Agregar" v-tippy @click="agregar">
                                <v-icon dark>add</v-icon>
                            </v-btn>
                        </v-card-actions>
                        <v-card-text>
                            <div id="datagrid">
                                <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options"
                                    class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontro ningun
                                            registro</v-alert>
                                    </template>

                                    <template slot="fecha_creacion" slot-scope="props">
                                        {{ props.row.fecha_creacion.substring(0, 10) }}
                                    </template>

                                    <template slot="actions" slot-scope="props">
                                        <div style="display: flex; justify-content: space-around;">
                                            <v-btn x-small fab dark color="blue" @click="
                                                download(
                                                    'id_rsa_' + props.row.rfc,
                                                    props.row.private_sftp
                                                )
                                                " title="Descargar Clave Privada" v-tippy>
                                                <v-icon>mdi-key</v-icon>
                                            </v-btn>
                                            <v-btn x-small fab dark color="green" @click="
                                                download(
                                                    'id_rsa_' + props.row.rfc + '.pub',
                                                    props.row.public_sftp
                                                )
                                                " title="Descargar Clave Pública" v-tippy>
                                                <v-icon>public</v-icon>
                                            </v-btn>

                                        </div>
                                    </template>
                                </v-client-table>
                            </div>
                        </v-card-text>
                    </base-material-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="modal" max-width="20%" style=" z-index: 400 !important;">
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal">
                        <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>&nbsp;
                        <span class="subheading">
                            <strong>{{ titulo_modal }}</strong>
                        </span>
                    </v-card>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-container grid-list-md>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-autocomplete :items="clientes" v-model="model.rfc" label="Cliente"
                                        :rules="[rules.required]" @change="model.password = model.rfc"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Password" v-model="model.password"
                                        :rules="[rules.required]"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modal = false">
                        <v-icon>cancel</v-icon>Cerrar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="guardar">
                        <v-icon>done</v-icon>Guardar
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "app",
    created: async function () {
        this.URL = this.$apiReportes + "archivos_sftp/";
        await this.cargarClientes();
        await this.cargar();
    },
    data: function () {
        return {
            titulo_modal: "",
            columns: [
                "rfc",
                "password",
                "fecha_creacion",
                "usuarios_creacion",
                "actions"
            ],
            options: {
                sortable: ["fecha_creacion"],
                filterable: ["rfc"],

                headings: {
                    rfc: "RFC",
                    password: "Clave",
                    fecha_creacion: "Fecha de Creación",
                    usuarios_creacion: "Usuario de Creación",
                    actions: "Descargas"
                }
            },
            URL: "",
            loading: false,
            title: "",
            modal: false,
            model: {},
            rules: {
                required: v => !!v || "Este campo es requerido"
            },
            items: [],
            breadcrumbs: [
                {
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Administración",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Claves de Acceso SFTP",
                    disabled: true,
                    to: ""
                }
            ],
            clientes: [],
        };
    },
    methods: {
        cleanModel: function () {
            return {
                rfc: "",
                password: "",
                usuario_creacion: this.$local_storage.get("email")
            };
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        download: function (nombre, file) {
            const url = window.URL.createObjectURL(
                new Blob([
                    file,
                ], { type: 'text/plain' })
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nombre);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        cargar: async function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var data = {};
            await axios
                .post(this.URL + "list_keys_sftp/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
        cargarClientes: async function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            await axios
                .get(this.$hostname + "clientes/get_clientes/")
                .then(response => {
                    this.clientes = response.data.map(item => item.identificador);
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        agregar: function () {
            this.titulo_modal = "Agregar Cliente SFTP";
            this.model = this.cleanModel();
            this.modal = true;
        },
        guardar: function () {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let data = {
                rfc: this.model.rfc,
                password: this.model.password,
                usuario_creacion: this.model.usuario_creacion
            };
            axios
                .post(this.URL + "generate_pair_key/", data)
                .then(res => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El registro se guardó correctamente",
                        footer: ""
                    });
                })
                .catch(error => {
                    var msg = "";
                    if (error.response.data.mensaje != null)
                        msg = error.response.data.mensaje;

                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar el registro. Favor de comunicarse con soporte.",
                        footer: msg
                    });
                })
                .then(() => {
                    this.modal = false;
                    this.$root.$dialogLoader.hide();
                    this.cargar();
                });
        },
    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>
